function getResolutionVal() {
	var winWidth = jQuery(window).width();
	if (winWidth > 1366) {
		return 'large';
	} else if (winWidth > 1024) {
		return 'medium';
	} else {
		return 'small';
	}
}

function qParamToList(listStr) {
	if (!listStr)
		return [];
	listStr = decodeURIComponent(listStr).replace(/\+/g, ' ');
	var list = listStr.split(',');
	for (var i = 0; i < list.length; ++i) {
		list[i] = list[i].replace(/@@##/g, ',');
		list[i] = list[i].replace(/@@\*\*/g, '/');
	}
	return list;
}

function selectRow(index, $scope) {
	$scope.selectedRow = index;
}

function updateConfig(tableState, $scope, tableConfig) {
	if (!tableState) {
		tableState = {};
	}
	if (!tableConfig) {
		tableConfig = {};
	}
	if (tableState.sort)
		tableConfig.sorters = $scope.tableService.convertSortToBackend(tableState.sort);
	else
		tableConfig.sorters = [];
	if (!tableConfig.recordsPerPage) {
		tableConfig.recordsPerPage = 0;
	}
	tableConfig.filters = $scope.filterService.getFilterConfigForStorage();
	// Don't store item search term for now
	tableConfig.search = ''; // shortagesFilterService.getSearchBoxDataValue();
	var widMap = {};
	if (tableConfig.columns) {
		for (var i = 0; i < tableConfig.columns.length; i++) {
			widMap[tableConfig.columns[i].name] = tableConfig.columns[i].width;
		}
	}
	tableConfig.columns = [];
	var resolutionVal = getResolutionVal();
	var i = 0;
	angular.forEach($scope.columns, function (column) {
		var wid = jQuery('#header' + column.id).innerWidth();
		var widObj = widMap[column.id] ? widMap[column.id] : {};
		widObj[resolutionVal] = wid;
		var columnToStore = {
			'name': column.id,
			'show': column.active ? true : false,
			'order': i,
			'width': widObj
		};
		tableConfig.columns.push(columnToStore);
	});
	angular.forEach($scope.doubleHeadersTop, function (column) {
		var wid = jQuery('#header' + column.id).innerWidth();
		var widObj = widMap[column.id] ? widMap[column.id] : {};
		widObj[resolutionVal] = wid;
		var columnToStore = {
			'name': column.id,
			'show': column.active ? true : false,
			'order': i,
			'width': widObj
		};
		tableConfig.columns.push(columnToStore);
	});
	$scope.tableService.updateConfig(tableConfig);
}

function toggleColumn(id, $scope, lastTableState, $timeout, tableConfig, repeat) {
	if (repeat) {
		if (isShowHideOpen()) {
			$timeout(function () {
				toggleColumn(id, $scope, lastTableState, $timeout, tableConfig, repeat);
			}, 100);
		} else {
			$scope.repeatLoop = false;
			$scope.activeColumns.length = 0;
			angular.forEach($scope.columns, function (col) {
				if (col.active) {
					$scope.activeColumns.push(col);
				}
			});
			$scope.addRowsWithJquery();
			$timeout(function () {
				updateWidths($timeout, $scope.columns, id);
			}, 0);
			if ($scope.initialReadFromConfig) $scope.initialReadFromConfig = false;
			updateConfig(lastTableState, $scope, tableConfig);
		}
	} else {
		var index = 0;
		var clmn = {};
		angular.forEach($scope.columns, function (col) {
			if (col.id === id) {
				col.active = !col.active;
			}
		});
		if ($scope.repeatLoop) {
			return;
		} else {
			$scope.repeatLoop = true;
			toggleColumn(id, $scope, lastTableState, $timeout, tableConfig, true);
		}
	}
}

function isShowHideOpen() {
	return jQuery('.advancedOptions.open .filter-menu .dropdown-submenu.open').length > 0;
}

function exportToExcelNew($scope, $uibModal, lastTableState, extraParams, modalScope, $experiments) {
	if (!$scope.doChooseColumns) {
		return $scope.tableService.getExcelNew(lastTableState, extraParams, modalScope, $scope);
	}
	var args = {};
	var chooseColumnScope = $scope.$new();
	chooseColumnScope.args = args;
	var opts = {
		scope: chooseColumnScope,
		windowClass: 'uib-modal-z-above-pendo',
		backdropClass: 'uib-modal-backdrop-z-above-pendo',
		templateUrl: '/application/f/reports/excel-export-choose-columns.html'
	};

	chooseColumnScope.doExport = function(args) {
		if (instance) {
			instance.close();
			chooseColumnScope.$destroy();
		}
		$scope.tableService.getExcelNew(lastTableState, extraParams, modalScope, $scope, args);
	};

	var instance = $uibModal.open(opts);
	chooseColumnScope.closeDialog = function() {
		instance.close();
		chooseColumnScope.$destroy();
	};
}

function exportToExcel($scope, $uibModal, lastTableState, extraParams) {
	//Use this for excel
	var modalScope = $scope.$new();
	modalScope.loadingMessage = 'Exporting...';
	var opts = {
		scope: modalScope,
		templateUrl: '/application/f/core/loading.html',
		windowClass: 'center-modal legacy',
		animation: false,
		windowTemplateUrl: '/application/f/core/loading-template.html',
		backdrop: 'static'
	};
	var instance = $uibModal.open(opts);
	$scope.tableService.getExcel(lastTableState, instance, extraParams);
}

function getNextDays(numDays) {
	var result = {};
	var start = new Date();
	var end = new Date();
	end.setDate(start.getDate() + numDays);
	var monthStart = (start.getMonth() + 1) < 10 ? '0' + (start.getMonth() + 1) : start.getMonth() + 1;
	var monthEnd = (end.getMonth() + 1) < 10 ? '0' + (end.getMonth() + 1) : end.getMonth() + 1;
	var dayStart = start.getDate() < 10 ? '0' + start.getDate() : start.getDate();
	var dayEnd = end.getDate() < 10 ? '0' + end.getDate() : end.getDate();
	result.start = start.getFullYear() + '-' + monthStart + '-' + dayStart;
	result.end = end.getFullYear() + '-' + monthEnd + '-' + dayEnd;
	return result;
}

function numberOfDecimals(val, defaultDec, keepAllDecimals) {
	var decimals = defaultDec;
	if (!decimals && decimals !== 0)
		decimals = 2;
	if (keepAllDecimals) {
		var valTmp = '' + scientificToDecimal(val);
		var valSplit = valTmp.split('.');
		if (valSplit && valSplit.length == 2) {
			valTmp = valSplit[1].replace(/0+$/, '');
			return valTmp.length;
		} else {
			return 0;
		}
	}
	if (val == 0) {
		decimals = 0;
	} else if (val < 0.0000001 && val > -0.0000001 && decimals < 9) {
		decimals = 9;
	} else if (val < 0.000001 && val > -0.000001 && decimals < 8) {
		decimals = 8;
	} else if (val < 0.00001 && val > -0.00001 && decimals < 7) {
		decimals = 7;
	} else if (val < 0.0001 && val > -0.0001 && decimals < 6) {
		decimals = 6;
	} else if (val < 0.001 && val > -0.001 && decimals < 5) {
		decimals = 5;
	} else if (val < 0.01 && val > -0.01 && decimals < 4) {
		decimals = 4;
	} else if (val < 0.1 && val > -0.1 && decimals < 3) {
		decimals = 3;
	} else if (val < 1 && val > -1 && decimals < 2) {
		decimals = 2;
	} else if (val < 10 && val > -10 && decimals < 2) {
		// This is to add a number less than 10 to show 2 decimals if it is a decimal number
		var valStr = '' + val;
		var valStrSplit = valStr.split('.');
		if (valStrSplit && valStrSplit.length === 2) {
			valStr = valStrSplit[1].replace(/0+$/, '');
			decimals = Math.min(valStr.length, 2);
		}
	}
	if (val > 10 || val < -10) {
		if (!defaultDec) {
			decimals = 0;
		} else {
			decimals = defaultDec;
		}
	}
	return decimals;
}

function getInternetExplorerVersion() {
	// Returns the version of Internet Explorer or a -1
	// (indicating the use of another browser).
	var rv = -1; // Return value assumes failure.
	if (navigator.appName == 'Microsoft Internet Explorer') {
		var ua = navigator.userAgent;
		var re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
		if (re.exec(ua) != null)
			rv = parseFloat(RegExp.$1);
	} else if (navigator.appName == 'Netscape') {
		var ua = navigator.userAgent;
		var re = new RegExp('Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})');
		if (re.exec(ua) != null)
			rv = parseFloat(RegExp.$1);
	}
	return rv;
}

function scientificToDecimal(num) {
	//https://gist.github.com/jiggzson/b5f489af9ad931e3d186
	//if the number is in scientific notation remove it
	if(/\d+\.?\d*e[\+\-]*\d+/i.test(num)) {
		var zero = '0',
			parts = String(num).toLowerCase().split('e'), //split into coeff and exponent
			e = parts.pop(),//store the exponential part
			l = Math.abs(e), //get the number of zeros
			sign = e/l,
			coeff_array = parts[0].split('.');
		if(sign === -1) {
			num = zero + '.' + new Array(l).join(zero) + coeff_array.join('');
		}
		else {
			var dec = coeff_array[1];
			if(dec) l = l - dec.length;
			num = coeff_array.join('') + new Array(l+1).join(zero);
		}
	}

	return num;
};
